import { call, put, takeEvery } from "redux-saga/effects"

import { GET_ALL_USER } from "./actionTypes"

import { getAllUsersSuccess, getAllUsersFail } from "./actions"

import { getAllUser } from "../../../helpers/backend_helper"

function* fetchUsers() {
  try {
    const response = yield call(getAllUser)
    yield put(getAllUsersSuccess(response))
  } catch (error) {
    yield put(getAllUsersFail(error))
  }
}

function* UserSaga() {
  yield takeEvery(GET_ALL_USER, fetchUsers)
}

export default UserSaga
